export default {
  title: 'Directions',
  sections: {
    main: {
      fields: {
        value: {
          title: 'Directions to the SEU headquarters',
          subTitle: 'How to find us',
          text: 'Our premises are located just a 3-minute walk from the Pfäffikon train station. The “Wunderraum” office building has its own underground parking garage with entrance from Huobstrasse. Additional parking is available in the Huob underground parking garage or at Pfäffikon train station.',
          buttonLabel: 'SHOW ON GOOGLE MAPS',
          buttonLink: 'https://www.google.com/maps?saddr=My+Location&daddr=47.20113,8.78043',
        },
      }
    }
  }
}
